const AnjuAllReleases2022Static = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Music Video / Single</p>
            <a href="https://www.youtube.com/watch?v=0PDDyumLrYo" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-wDezjcyyNBP4WjQZ-zFdTCg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>SWAG SUPPLIER</strong><br/>(feat. Kawaii Ry & STARINTHESKY)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://open.spotify.com/track/1OeOaYFIieCjVVn2Yl2Qxh?si=e01a3bf087db4d9e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273f8f425ed3f229026f4806269" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Mr. Drill / pist off</strong><br/>(feat. Kawaii Ry)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://open.spotify.com/track/1AYPa7Fn3NhxQXzU6Z5jsA?si=be828dc4843b40fa" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-QD3RqZW3V4fKs7pr-jNLnBQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Lugosi - ghostsinthewalls</strong><br/>
                (prod. ANJU Online!)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Placement</p>
            <a href="https://soundcloud.com/kawaiiry/kawaiiry-we-all-change-its-okay-prod-anjuonline" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-M0Rzq7jdHWKlMJHT-ormDZw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - we all change and thats okay</strong><br/>
                (prod. ANJU Online!)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Single</p>
            <a href="https://soundcloud.com/hellscapedigital/camo-croc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-M65REbxvpBKAYv1s-c35jbg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Camo Croc</strong><br/>
                (feat. Kawaii Ry)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default AnjuAllReleases2022Static;